<template>
  <b-modal
    :id="id"
    ref="imageEditor"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    title="Téléchargement"
    size="md"
    :modal-class="'base-modal'"
    @shown="handleShown"
    @hide="close"
  >
    <b-container>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        alt="Image editor"
        :movable="false"
        :zoomable="false"
        :autoCropArea="1"
      >
      </vue-cropper>
    </b-container>
    <div slot="modal-footer" class="w-100">
      <div class="footer-action float-right">
        <b-button
          variant="outline-primary"
          size="md"
          class="mx-2"
          @click="close"
        >
          Annuler
        </b-button>
        <b-button
          variant="primary"
          size="md"
          @click="exportSchema"
        >
          Exporter
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import FileSaver from 'file-saver'
import 'canvas-toBlob'

export default {
  components: {
    VueCropper
  },
  props: {
    id: {
      type: String,
      default: 'image-editor'
    },
    initialSize: {
      type: Object,
      default: () => ({w: 1900, h: 2340})
    }
  },
  data () {
    return {
      imgSrc: require('@/assets/images/editorplaceholder.png'),
      fileName: 'schema.png'
    }
  },
  methods: {
    open ({src, fileName}) {
      this.imgSrc = src
      this.fileName = fileName
      this.$refs.imageEditor.show()
    },
    close () {
      this.imgSrc = require('@/assets/images/editorplaceholder.png')
      this.fileName = 'schema.png'
      this.$refs.imageEditor.hide()
    },
    handleShown () {
      this.$refs.cropper.replace(this.imgSrc)
    },
    exportSchema () {
      this.$refs.cropper.getCroppedCanvas({
        width: this.initialSize.w,
        height: this.initialSize.h,
        maxWidth: this.initialSize.w,
        maxHeight: this.initialSize.h,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      }).toBlob((blob) => {
        FileSaver.saveAs(blob, `${this.fileName}`)
        this.close()
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/utils/imageEditor.vue